import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { MongoDbAtlasDataset } from 'app/model/dataset/mongo-db-atlas.dataset';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { HierarchicalNode } from 'app/model/dataset/hierarchicalnode';
import { TabularTypeDatasetAdapter } from './tabular-type.dataset.adapter';
import { parseJsonSchema } from './json.dataset.adapter';
import { ValueAdapter } from '../value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MongoDbAtlasDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            folder: '*',
            annotations: '*',
            linkedServiceName: '*',
            parameters: '*',
            type: '*',
            version: __IS_FABRIC_DPE__ ? '*' : undefined,
            typeProperties: {
                collection: '*',
                database: __IS_FABRIC_DPE__ ? '*' : undefined
            }
        }
    }
})
export class MongoDbAtlasDatasetAdapter extends TabularTypeDatasetAdapter<MongoDbAtlasDataset, Model.DatasetResource> {
    public parseHierarchicalSchema(obj: unknown): HierarchicalNode {
        try {
            return parseJsonSchema(obj, 'schema');
        } catch {
            return undefined;
        }
    }

    protected async _toResource(dataset: MongoDbAtlasDataset): Promise<Model.DatasetResource> {
        const modelDataset = await this._toResourceInternal(dataset, Metamodel.modelFor(MongoDbAtlasDataset).name, 'collection');
        if ((__IS_FABRIC_DPE__ || this.context.adapterConfig.convertToFabric)) {
            if (__IS_FABRIC_DPE__) {
                // TODO - ans - handle version for migration
                modelDataset.properties.version = ValueAdapter.toResource(
                    dataset,
                    MongoDbAtlasDataset.VERSION
                );
            }

            modelDataset.properties.typeProperties.database = ValueAdapter.toResource(
                dataset,
                MongoDbAtlasDataset.DATABASE
            );
        }
        return modelDataset;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: MongoDbAtlasDataset): Promise<MongoDbAtlasDataset> {
        dataset = await this._toModelInternal(modelDatasetResource, dataset, MongoDbAtlasDataset.MODEL, 'collection');

        if (__IS_FABRIC_DPE__) {
            dataset.version = undefined;
            ValueAdapter.toModel(
                dataset,
                MongoDbAtlasDataset.VERSION,
                modelDatasetResource.properties?.version
            );
        }

        if (modelDatasetResource.properties?.typeProperties) {
            ValueAdapter.toModel(
                dataset,
                MongoDbAtlasDataset.DATABASE,
                modelDatasetResource.properties.typeProperties.database
            );
        }
        return dataset;
    }
}
